import automationsList from "servicestack/automations/automations-list";
import automationsCenter from "servicestack/automations/automations-center";
import recipesList from "servicestack/automations/recipes-list";

export default app =>
	app
		.component("automationsList", automationsList)
		.component("automationsCenter", automationsCenter)
		.component("recipesList", recipesList);
